export default __webpack_public_path__ + "static/media/robin_4.75bf23db.mp3";